export default __webpack_public_path__ + "static/media/menu-open-icon.4356ade9.svg";